<template>
<div class="stage">
  <main>
    <div class="">

      <div class="position-relative">
        <section class="story-banner">
          <stage-banner :title="title"></stage-banner>
        </section>

        <section class="story" id="story">
          <div class="container">

            <div class="story-content">

              <div>
                <b-button v-b-modal.chapterselect variant="light" size="sm" class="mb-3 py-0 px-2">
                  <span class="font-weight-bold">章節選擇</span>
                </b-button>
              </div>

              <!-- 要改的內容 -->
              <npc :npc-id="1" right>林先生⋯⋯！</npc>
              <npc :npc-id="0">勇士當為義鬥爭⋯⋯嗎？果然你早就下決定了⋯⋯</npc>
              <npc :npc-id="1" right>呂善安，這個空間⋯⋯跟剛剛不一樣了！</npc>
              <npc :npc-id="0">大概是時空穩定了，我們也被彈回原來的時空了吧？</npc>
              <npc :npc-id="1" right>咦？你手上的賴和面具⋯⋯</npc>

              <story-image :src="require(`@/assets/images/pics/第8章_3-1_賴和面具背面紙條.png`)"></story-image>
              <!-- （圖片：賴和面具背面的圖，裡面貼了一張紙） -->

              <npc :npc-id="1" right>『將名片交給賴和紀念館』⋯⋯</npc>
              <npc :npc-id="0">看來林先生還留下了什麼。</npc>
              <npc :npc-id="1" right>林先生早就料到事情會變這樣嗎？</npc>
              <npc :npc-id="0">我也不清楚，但賴和紀念館應該有答案；走吧，前往這趟旅程的終點。</npc>

              <map-link name="賴和紀念館" map-id="9mQJy4U73NbXZrCr5"/>

              <move-to-stage-btn link="前往賴和紀念館">前往賴和紀念館</move-to-stage-btn>

              <!-- 要改的內容到此 -->

            </div>

          </div>
        </section>
      </div>


      <div class="top-level">
        <top-bottom-button :question="isQuestion"></top-bottom-button>

        <b-modal id="chapterselect" hide-footer title="選擇章節">
          <chapter-select :now-stage="stageId"></chapter-select>
        </b-modal>
      </div>

    </div>
  </main>
</div>
</template>

<script>
// import Cookie from '@/utilities/Cookie.js'
import StageBanner from '@/components/StageBanner.vue'
import TopBottomButton from '@/components/TopBottomButton.vue'
import ChapterSelect from '@/components/ChapterSelect.vue'
import '@/assets/css/stage.css'

export default {
  name: 'Stage8_3',
  components: {
    StageBanner,
    TopBottomButton,
    ChapterSelect,
  },
  props: {},
  data() {
    return {
      title: '第八章 - 3',
      isQuestion: false,
      stageId: 'brave',
    };
  },
  mounted() {
    window.scrollTo(0, 0);
  },
  methods: {

  }
}
</script>

<style scoped>

</style>
